(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequency', {
            parent: 'entity',
            url: '/frequency',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.frequency.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequency/frequencies.html',
                    controller: 'FrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequency');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequency-detail', {
            parent: 'entity',
            url: '/frequency/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.frequency.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequency/frequency-detail.html',
                    controller: 'FrequencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequency');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Frequency', function($stateParams, Frequency) {
                    return Frequency.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('frequency.new', {
            parent: 'frequency',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-dialog.html',
                    controller: 'FrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('frequency');
                });
            }]
        })
        .state('frequency.edit', {
            parent: 'frequency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-dialog.html',
                    controller: 'FrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Frequency', function(Frequency) {
                            return Frequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequency.delete', {
            parent: 'frequency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-delete-dialog.html',
                    controller: 'FrequencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Frequency', function(Frequency) {
                            return Frequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
